<!--督办-->
<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="督办" size="40%"
               :before-close="handleClose"
               :visible.sync="visiable"
               direction="rtl" append-to-body
               custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">


        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;"/>
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
                      formData.orderNo
                    }}</span>
                    <!-- 服务类型 -->
                    <span class="information">{{ formData.serverTypeName }}</span>

                    <!-- 工单状态 -->
                    <span class="information" v-if="formData.stat == 1">登记</span>
                    <span class="information" v-else-if="formData.stat == 2">发布</span>
                    <span class="information" v-else-if="formData.stat == 5">已派网点</span>
                    <span class="information" v-else-if="formData.stat == 6">网点已接单</span>
                    <span class="information" v-else-if="formData.stat == 9">已派师傅</span>
                    <span class="information" v-else-if="formData.stat == 10">师傅已接单</span>
                    <span class="information" v-else-if="formData.stat == 11">已预约</span>
                    <span class="information" v-else-if="formData.stat == 13">已出发</span>
                    <span class="information" v-else-if="formData.stat == 17">已上门</span>
                    <span class="information" v-else-if="formData.stat == 20">完工暂存</span>
                    <span class="information" v-else-if="formData.stat == 30">寄修待确认</span>
                    <span class="information" v-else-if="formData.stat == 31">待寄件</span>
                    <span class="information" v-else-if="formData.stat == 32">已寄待签收</span>
                    <span class="information" v-else-if="formData.stat == 36">待维修</span>
                    <span class="information" v-else-if="formData.stat == 37">修好待寄出</span>
                    <span class="information" v-else-if="formData.stat == 38">客户待签收</span>
                    <span class="information" v-else-if="formData.stat == 40">退换待确认</span>
                    <span class="information" v-else-if="formData.stat == 41">旧机待退回</span>
                    <span class="information" v-else-if="formData.stat == 42">旧机待签收</span>
                    <span class="information" v-else-if="formData.stat == 43">旧机已签收</span>
                    <span class="information" v-else-if="formData.stat == 44">新机待寄出</span>
                    <span class="information" v-else-if="formData.stat == 45">新机已寄出</span>
                    <span class="information" v-else-if="formData.stat == 47">新机待签收</span>
                    <span class="information" v-else-if="formData.stat == 48">新机已签收</span>
                    <span class="information" v-else-if="formData.stat == 49">退换被驳回</span>
                    <span class="information" v-else-if="formData.stat == 61">已完工</span>
                    <span class="information" v-else-if="formData.stat == 62">网点确认完工</span>
                    <span class="information" v-else-if="formData.stat == 63">中心完工审核</span>
                    <span class="information" v-else-if="formData.stat == 64">总部完工审核</span>
                    <span class="information" v-else-if="formData.stat == 91">待结算</span>
                    <span class="information" v-else-if="formData.stat == 92">结算驳回</span>
                    <span class="information" v-else-if="formData.stat == 93">结算中止</span>
                    <span class="information" v-else-if="formData.stat == 94">已结算</span>
                    <span class="information" v-else-if="formData.stat == 97">申请关闭</span>
                    <span class="information" v-else-if="formData.stat == 98">挂起</span>
                    <span class="information" v-else-if="formData.stat == 99">取消</span>
                    <span class="information" v-else></span>
                  </div>
                </div>


                <el-form-item label="督办人" style="display:flex" :rules="{required: true}">
                  <handle-pop-search :handle-id.sync="formData.handleId"
                                     :handle-name.sync="formData.handleName"
                                     style="width: 10vw;"
                  />
                </el-form-item>

                <el-form-item label="督办时间" style="display:flex" :rules="{required: true}">
                  <el-date-picker v-model="formData.handleTime"
                                  :picker-options="{
                                         disabledDate: time => {
                                             return time < new Date()
                                         }
                                      }"
                                  style="width: 10vw;"
                                  type="datetime"
                                  placeholder="选择日期时间"
                                  align="right"
                                  default-time="12:00:00"
                                  value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="督办事项" style="display:flex" :rules="{required: true}">
                  <dict-select dict-type="督办事项"
                               :dict-item-id.sync="formData.handleMatter"
                               :dict-item-name.sync="formData.handleMatterName"
                               style="width: 10vw;"
                  />
                </el-form-item>

              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="commit">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";
import CheckSubjectSearch from "@/components/formItem/checkSubjectSearch.vue";
import HandlePopSearch from "@/components/formItem/handlePopSearch.vue";

export default {
  name: 'supervisingDialog',
  components: {HandlePopSearch, CheckSubjectSearch, DictSelect},
  props: ['multi', 'rowData', 'visiable'],
  created() {
    this.$objCopy(this.rowData, this.formData)
    this.formData.remark = null
  },
  data() {
    return {
      formData: {
        result: null,
        remark: null,
        handleId: null,  //督办人ID
        handleName: null,  //督办人名称
        handleTime: null,
        handleMatter: null,
        handleMatterName: null,

        id: null,
        orderNo: null,
        serverTypeName: null,
        stat: null,
      },
    }
  },
  watch: {

  },
  methods: {
    commit() {
      let rules = {
        handleId: [{prop: '督办人', required: true}],
        handleTime: [{prop: '督办时间', required: true}],
        handleMatter: [{prop: '督办事项', required: true}],
      }

      this.$validate(this.formData, rules).then(res => {
        this.$mask.open()
        this.$http({
          url: api.soOrder.supervisingUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('操作成功')
          this.handleClose()
          this.$emit('goBackIndex')
        }).catch(() => {
          this.$mask.close()
        })
      })
    },


    confirm() {
      this.handleClose()
    },
    cancelForm() {
      this.handleClose()
    },
    handleClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}

::v-deep .el-form-item .el-form-item__label {
  font-size: 12px;
  font-weight: 400;
  width: 100px;
}
</style>
